module.exports = __webpack_public_path__ + "img/rightcalf-endo-mesomorph-male.e837b33b.svg";